// NEW: src/components/question-bank-intro-slide.jsx
//
// Section-break slide shown once between the last microQuiz of the last
// concept and the question-bank items. Sky-blue gradient background
// matches the section-marker / chapter-end look, so it reads as "new
// section" the moment it appears.
//
// Pure render — the parent (EnhancedLearnMode) hides the shared Next/Back
// nav for this slide type. The single green CTA here is the only way
// forward.

import { getFontFamily } from "../constants/colors";

const COUNT_TYPES = [
  { key: "MCQ",       label: "MCQ" },
  { key: "short",     label: "Short" },
  { key: "proof",     label: "Proof" },
  { key: "caseStudy", label: "Case" },
];

export function QuestionBankIntroSlide({ questionBank, onNext, lang }) {
  const ff = getFontFamily(lang);
  const bank = Array.isArray(questionBank) ? questionBank : [];
  const total = bank.length;

  // Per-type counts, rendered only for types that actually appear.
  const counts = bank.reduce((acc, q) => {
    const t = q?.type;
    if (t) acc[t] = (acc[t] || 0) + 1;
    return acc;
  }, {});
  const statsBits = COUNT_TYPES
    .filter(({ key }) => counts[key])
    .map(({ key, label }) => `${counts[key]} ${label}`);
  const statsLine = statsBits.join(" · ");

  return (
    <div style={{
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "40px 24px",
      background: "linear-gradient(180deg, #6AAAC8 0%, #8BC4D8 100%)",
      fontFamily: ff,
      textAlign: "center",
      width: "100%",
      boxSizing: "border-box",
    }}>
      <div />

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
        <div style={{ fontSize: 64, lineHeight: 1 }} aria-hidden="true">📝</div>

        <div style={{
          fontSize: 28,
          fontWeight: 700,
          color: "#FFFFFF",
          lineHeight: 1.2,
          fontFamily: ff,
          letterSpacing: "-0.01em",
        }}>
          Chapter Exercises
        </div>

        <div style={{
          fontSize: 16,
          color: "rgba(255,255,255,0.85)",
          lineHeight: 1.5,
          maxWidth: 280,
          fontFamily: ff,
        }}>
          {total} {total === 1 ? "question" : "questions"} covering what you learned.
        </div>

        {total > 0 && statsLine && (
          <div style={{
            fontSize: 13,
            color: "rgba(255,255,255,0.7)",
            fontFamily: ff,
            marginTop: 4,
          }}>
            {statsLine}
          </div>
        )}
      </div>

      <button
        onClick={onNext}
        style={{
          background: "#1A7A52",
          color: "#FFFFFF",
          border: "none",
          borderRadius: 12,
          padding: "14px 28px",
          fontSize: 16,
          fontWeight: 600,
          fontFamily: ff,
          cursor: "pointer",
          minHeight: 44,
          minWidth: 44,
          boxShadow: "0 4px 14px rgba(26,122,82,0.3)",
          letterSpacing: "-0.01em",
        }}>
        Start exercises
      </button>
    </div>
  );
}

export default QuestionBankIntroSlide;
